export default __webpack_public_path__ + "static/media/person_3@2x.87c1f6c8.png";